/**
* PulseBetProgressData defines the data for the progress bar animation
*
* @typedef PulseBetProgressData
* @type {type}
* @property {periods} periods Collection with the periods in the bet
* @property {startTime} startTime Indicates what is the beggining point of the bet
* @property {endTime} endTime Indicates what is the ending point of the bet
* @property {expiredBetProgressInMilliseconds} expiredBetProgressInMilliseconds Indicates the already passed progress in the bet
*/
var PulseBetProgressData = /** @class */ (function () {
    function PulseBetProgressData(source) {
        this.periods = source.periods;
        this.startTime = source.startTime;
        this.endTime = source.endTime;
        this.expiredBetProgressInMilliseconds = source.expiredBetProgressInMilliseconds;
        this.id = source.id;
    }
    return PulseBetProgressData;
}());
export { PulseBetProgressData };
//# sourceMappingURL=PulseBetProgressData.js.map